import { useState } from 'react';
import { Modal, OverlayTrigger, Popover, Button } from 'react-bootstrap';
import { BP_LEVELS } from '../../utils/bpCategory';

const ROWS = [
    { level: 'normal',   name: 'NORMAL',                                              sys: 'LESS THAN 120', join: 'and',    dia: 'LESS THAN 80' },
    { level: 'elevated', name: 'ELEVATED',                                            sys: '120 – 129',     join: 'and',    dia: 'LESS THAN 80' },
    { level: 'stage1',   name: 'HIGH BLOOD PRESSURE (HYPERTENSION) STAGE 1',          sys: '130 – 139',     join: 'or',     dia: '80 – 89' },
    { level: 'stage2',   name: 'HIGH BLOOD PRESSURE (HYPERTENSION) STAGE 2',          sys: '140 OR HIGHER', join: 'or',     dia: '90 OR HIGHER' },
    { level: 'crisis',   name: 'HYPERTENSIVE CRISIS (consult your doctor immediately)', sys: 'HIGHER THAN 180', join: 'and/or', dia: 'HIGHER THAN 120' },
];

export const BpChart = ({ compact }) => {
    const fs = compact ? '11px' : '14px';
    const pad = compact ? '6px 8px' : '12px 14px';
    const head = { background: '#4a4a4a', color: '#fff', padding: pad, fontSize: fs, textAlign: 'center', fontWeight: 700 };
    return (
        <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '2px', fontFamily: 'Arial, sans-serif' }}>
            <thead>
                <tr>
                    <th style={{ ...head, textAlign: 'left' }}>BLOOD PRESSURE CATEGORY</th>
                    <th style={head}>SYSTOLIC mm Hg<br /><small>(upper number)</small></th>
                    <th style={{ ...head, background: 'transparent' }}></th>
                    <th style={head}>DIASTOLIC mm Hg<br /><small>(lower number)</small></th>
                </tr>
            </thead>
            <tbody>
                {ROWS.map((r) => {
                    const lv = BP_LEVELS[r.level];
                    const cell = { background: lv.color, color: lv.text, padding: pad, fontSize: fs, fontWeight: 700, textAlign: 'center' };
                    return (
                        <tr key={r.level}>
                            <td style={{ ...cell, textAlign: 'left' }}>{r.name}</td>
                            <td style={cell}>{r.sys}</td>
                            <td style={{ ...cell, fontWeight: 400 }}>{r.join}</td>
                            <td style={cell}>{r.dia}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

// Small sidebar entry: hover shows the chart in a popover, click opens it in a modal.
const BpGuide = () => {
    const [show, setShow] = useState(false);
    const [hover, setHover] = useState(false);
    const open = () => { setHover(false); setShow(true); };
    const popover = (
        <Popover id="bp-guide-popover" style={{ maxWidth: '560px', width: '560px' }}>
            <Popover.Header as="h6">Blood Pressure Categories (AHA)</Popover.Header>
            <Popover.Body><BpChart compact /></Popover.Body>
        </Popover>
    );
    return (
        <>
            <li className="nav_link">
                <OverlayTrigger trigger={['hover', 'focus']} placement="right" show={hover && !show} onToggle={(next) => setHover(next && !show)} delay={{ show: 150, hide: 100 }} overlay={popover}>
                    <a href="#bp-guide" onClick={(e) => { e.preventDefault(); open(); }}>
                        <i className="fas fa-heartbeat" style={{ color: '#FEFFFF', fontSize: '24px' }}></i>
                        <span className="link_name">BP Guide</span>
                    </a>
                </OverlayTrigger>
            </li>
            <Modal show={show} onHide={() => setShow(false)} size="lg" centered restoreFocus={false}>
                <Modal.Header>
                    <Modal.Title>Blood Pressure Categories</Modal.Title>
                    <Button variant="outline-secondary" size="sm" onClick={() => setShow(false)}>Close</Button>
                </Modal.Header>
                <Modal.Body>
                    <BpChart />
                    <p className="text-muted mt-3 mb-0" style={{ fontSize: '12px' }}>
                        Source: American Heart Association / Harvard Health. Alerts in this portal use the higher of the systolic and diastolic categories.
                    </p>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default BpGuide;
